import React, { useEffect, useState } from "react";
import "./PrivacyPolicy.css";
import Header from "../../../Layout/Header/Header";
import Footer from "../../../Layout/Footer/Footer";
import { getPageDeatailsAPI } from "../../../../../Store/Action/pageAction";
import { useDispatch } from "react-redux";
import CustomLoader from "../../../CustomComponents/CustomLoader/CustomLoader";
import { pageSlug } from "../../../../../Constants/AppConstants";
import Icons from "../../../../../Config/Images";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();

  const [privacyPolicy, setPrivacyPolicy] = useState([]);
  const [header, setHeader] = useState("");
  const [isLoadind, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getPageDeatailsAPI(pageSlug.privacyPolicy, (result) => {
        // if (result?.status) {
        setHeader(result?.data?.[0]?.page_name);
        setPrivacyPolicy(result?.data?.[0].page_json);
        setIsLoading(false);
        // }
      })
    );
  }, [dispatch]);

  const renderTermsPoints = () =>
    privacyPolicy?.map((term, index) => (
      <div className="privacy-policy-point">
        <p>
          {term?.heading ? `${index + 1}.` : ``} {term?.heading}
        </p>
        <ul style={{ paddingLeft: "20px" }}>
          <li key={index}>{term?.content}</li>
        </ul>
      </div>
    ));
  return (
    <>
      {/* <Header /> */}
      <div
        className="terms-and-conditions-main-div with-overlay"
        style={{
          backgroundImage: `url(${Icons.zabali_header_logo_icon})`,
          backgroundSize: "auto",
          backgroundRepeat: "no-repeat",
          // backgroundPosition: "top center", // or 'center center'
          backgroundPosition: "center center",
        }}
      >
      <div className="privacy-policy-main-div">
        <div className="privacy-policy-header">
          <p className="privacy-policy-header-para">
            {header || "Privacy Policy"}
          </p>
        </div>
        <div className="divider" />
        {isLoadind ? (
          <div className="loaderContainer">
            <CustomLoader />
          </div>
        ) : (
          <div className="privacy-policy-container">{renderTermsPoints()}</div>
        )}
      </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
